import { render, staticRenderFns } from "./AttributeEditionRow.vue?vue&type=template&id=67f260bd&scoped=true&"
import script from "./AttributeEditionRow.vue?vue&type=script&lang=js&"
export * from "./AttributeEditionRow.vue?vue&type=script&lang=js&"
import style0 from "./AttributeEditionRow.vue?vue&type=style&index=0&id=67f260bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f260bd",
  null
  
)

export default component.exports